/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useState, useEffect } from "react";
import { useElementNavigation } from "./useElementNavigation";
import { useQueryState, QueryState } from "./useQueryState/useQueryState";

export function useTabStepNavigation(tabStepMapping: Record<string, number>) {
  const { currentHash, updateHash } = useElementNavigation();
  const [currentStep, setCurrentStep] = useState(0);
  const { replaceQueryState } = useQueryState<QueryState>();

  const handleTab = (step: number) => {
    replaceQueryState({}, "replace"); //remove all query params
    const tabKey =
      Object.keys(tabStepMapping).find((key) => tabStepMapping[key] === step) ??
      Object.keys(tabStepMapping)[0];
    updateHash(
      {
        tab: tabKey,
      },
      { merge: true }
    );
    setCurrentStep(step);
  };

  useEffect(() => {
    const hashTabKey = currentHash?.tab;
    const hashStep =
      hashTabKey && hashTabKey in tabStepMapping
        ? tabStepMapping[hashTabKey]
        : 0;
    if (hashStep !== currentStep) {
      setCurrentStep(hashStep);
    }
    if (hashTabKey && !(hashTabKey in tabStepMapping)) {
      // Clean up invalid tab hash from URL
      updateHash(
        {
          tab: null,
        },
        { merge: true }
      );
    }
  }, [currentHash, updateHash, tabStepMapping]);

  return { handleTab, currentStep };
}
